var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounLockDocument552848(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      enableBackground: "accumulate"
    },
    d: "m 18.000244,957.36217 c -1.7171,0.01 -3.0294,1.4947 -3,3 l 0,84.00003 c 2e-4,1.5708 1.4293,2.9998 3,3 l 63.999996,0 c 1.5708,-2e-4 2.9999,-1.4292 3,-3 l 0,-62.00003 c 0,-0.7861 -0.3201,-1.5681 -0.875,-2.125 l -22,-22 c -0.5568,-0.5549 -1.3388,-0.8769 -2.125,-0.875 l -41.999996,0 z m 3,6 35.999996,0 0,19 a 3.0003,3.0003 0 0 0 3,3 l 19,0 0,56.00003 -57.999996,0 0,-78.00003 z m 41.999996,4.2188 11.7812,11.7812 -11.7812,0 0,-11.7812 z m -13,26.7812 c -6.0421,0 -11,4.9579 -11,11.00003 l 0,3 c -0.4303,-10e-4 -0.9034,0 -1.3125,0 -1.4638,0.1534 -2.695396,1.5282 -2.687496,3 l 0,16 c 1.96e-4,1.5708 1.429296,2.9998 2.999996,3 l 24,0 c 1.5708,-2e-4 2.9999,-1.4292 3,-3 l 0,-16 c -1e-4,-1.5708 -1.4292,-2.9998 -3,-3 l -1,0 0,-3 c 0,-6.04213 -4.9579,-11.00003 -11,-11.00003 z m 0,6.00003 c 2.8219,0 5,2.1781 5,5 l 0,3 -10,0 0,-3 c 0,-2.8219 2.1781,-5 5,-5 z m -9,14 18,0 0,10 -18,0 0,-10 z",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLockDocument552848);
export default __webpack_public_path__ + "static/media/noun_lock_document_552848.797e9cbf.svg";
export { ForwardRef as ReactComponent };